export default __webpack_public_path__ + "static/media/project-scoring.4898e6c1.pdf";